function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconGridView = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 16"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M0 0h16v16H0z",
  style: {
    fill: "transparent"
  }
}), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(1 9)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 7,
  stroke: "none",
  rx: 1,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 0.5,
  y: 0.5,
  rx: 0.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "sp_header_area_line",
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(9 9)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 7,
  stroke: "none",
  rx: 1,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 0.5,
  y: 0.5,
  rx: 0.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "sp_header_area_line",
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(9 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 7,
  stroke: "none",
  rx: 1,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 0.5,
  y: 0.5,
  rx: 0.5,
  style: {
    fill: "none"
  }
})), /*#__PURE__*/React.createElement("g", {
  "data-name": "sp_header_area_line",
  style: {
    stroke: "#333",
    fill: "none"
  },
  transform: "translate(1 1)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 7,
  height: 7,
  stroke: "none",
  rx: 1,
  style: {
    stroke: "none"
  }
}), /*#__PURE__*/React.createElement("rect", {
  width: 6,
  height: 6,
  x: 0.5,
  y: 0.5,
  rx: 0.5,
  style: {
    fill: "none"
  }
})));
export default SvgIconGridView;